const func = $target => {     
    $target.modal();
};

export default func;